module.exports = __webpack_public_path__ + "static/media/wecan_uiux.8e32b495.svg";